module.exports = __webpack_public_path__ + "img/staff-erin-nolan.4f4035e0.jpg";